if (!customElements.get('zani-localization')) {
  customElements.define('zani-localization', class extends HTMLElement {
    connectedCallback() {
      if (this.boundChange) return;
      this.boundChange = (event) => {
        const select = event.target;
        if (!(select instanceof HTMLSelectElement) || !select.matches('[data-zani-localization-select]')) return;
        select.form?.requestSubmit();
      };
      this.addEventListener('change', this.boundChange);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.boundChange);
      this.boundChange = null;
    }
  });
}
